/**
 * Format Unix timestamp (seconds) to HH:MM for results headers.
 * Returns empty string if ts is missing or invalid.
 */
export function formatEventTimeToHHMM(ts: number | string | null | undefined): string {
  if (ts == null || ts === '') return '';
  const n = Number(ts);
  if (!Number.isFinite(n) || n <= 0) return '';
  return new Date(n * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
